import React from "react";
import Box from "@mui/material/Box";
import { NestiFyzGamesList } from "./NestifyzGamesList";
import { NestiFyzProfileComparison } from "./NestifyzProfileComparison";

/**
 * @param {object} props
 * @param {import("./parseExport").NestiFyzExport} props.NestiFyzExport
 */
export const NestiFyzExportPreview = ({ NestiFyzExport }) => {
  const { profile, games } = NestiFyzExport;

  return (
    <Box>
      <NestiFyzProfileComparison importedProfile={profile} />
      <NestiFyzGamesList games={games} />
    </Box>
  );
};
